import { StatusData } from '@oneethos/shared'
import { useState } from 'react'
import Amortization from './amortization'

type PaymentDetailsProps = {
  project: StatusData
}

export const PaymentDetails = ({ project }: PaymentDetailsProps) => {
  const [showAmortization, setShowAmortization] = useState(false)
  const hasProduct = Boolean(project.productId)

  return <div>
    <h6>Payment Details</h6>
    {showAmortization ?
      <>
        <Amortization statusData={project} />
        <div className="alert alert-danger" role="alert">
          This calculation assumes a Loan Date of today and may not match dates from original documents.
        </div>
      </> :
      <>
        {!hasProduct ? <div>
          Customer has not selected a product yet.
        </div> : <button type="button"
            className="btn btn-primary btn-sm"
            onClick={() => setShowAmortization(true)}>
            Calculate Payment Details
          </button>}
      </>
    }
  </div>
}